import './gb-terminal-pager.tag.html';
import './gb-pager.tag.html';
import './gb-pages.tag.html';
import { Paging } from './gb-paging';
riot.tag2('gb-paging', '<yield> <gb-terminal-pager> <gb-pager> <gb-pages></gb-pages> </gb-pager> </gb-terminal-pager> </yield>', '', '', function(opts) {
    this._mixin(Paging);
});



/** WEBPACK FOOTER **
 ** ./src/tags/paging/gb-paging.tag.html
 **/